/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { stripeWebHookIndex } from '../fn/stripe-web-hook/stripe-web-hook-index';
import { StripeWebHookIndex$Params } from '../fn/stripe-web-hook/stripe-web-hook-index';

@Injectable({ providedIn: 'root' })
export class StripeWebHookService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `stripeWebHookIndex()` */
  static readonly StripeWebHookIndexPath = '/api/StripeWebHook';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stripeWebHookIndex()` instead.
   *
   * This method doesn't expect any request body.
   */
  stripeWebHookIndex$Response(params?: StripeWebHookIndex$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return stripeWebHookIndex(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `stripeWebHookIndex$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  stripeWebHookIndex(params?: StripeWebHookIndex$Params, context?: HttpContext): Observable<void> {
    return this.stripeWebHookIndex$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
